import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatText } from 'core/i18n';
// @ Components
import { InfoTooltip } from 'components/tooltip/tooltip';
import { InputText } from 'components/inputText/inputText';
import PasswordRequirement from './passwordRequirement';
// @ Utilities
import { recordEvent } from 'utilities/uTagging';
import { checkAscDescValue, checkSameDigitsValue, checkNumeric, getSeparatedDate } from './utils';
import { birthYearMatchesPassword, birthDayMatchesPassword } from 'commonsUtilities/validations';
import StringHelper from 'utilities/stringHelper';

class Password extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showShakeAnimationOnPasswordError: false,
            errorPassNumeric: false,
            errorPassAscDesc: false,
            errorPassEquals: false,
            errorPassBirthDay: false,
            passValid: false,
            displayPassReq: false,
            inputType: 'tel',
            showPassword: false,
            passwordInputClass: 'password-number-input',
            iconPasswordClass: 'icon-pass-on show-password',
        };
    }

    handleTogglePassword = () => {
        let visiblePassword = this.state.showPassword;
        if (visiblePassword) {
            this.handleHidePassword();
        } else {
            this.handleShowPassword();
        }
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'clave de cliente',
            categoriaEvento: 'interaccion en datos personales',
            etiquetaEvento: visiblePassword ? 'ocultar' : 'mostrar',
        });
    };

    handleShowPassword = () => {
        this.setState({
            inputType: 'tel',
            passwordInputClass: '',
            iconPasswordClass: 'icon-pass-off show-password-off',
            showPassword: true,
        });
    };

    handleHidePassword = () => {
        this.setState({
            inputType: 'tel',
            passwordInputClass: 'password-number-input',
            iconPasswordClass: 'icon-pass-on show-password',
            showPassword: false,
        });
    };

    handlePasswordReq = (...args) => {
        const [errorPassNumeric, errorPassAscDesc, errorPassEquals, errorPassValidBirthDay] = args;
        const hasErrors = args.some(x => x);

        this.setState(
            {
                displayPassReq: hasErrors,
                showShakeAnimationOnPasswordError: hasErrors,
                errorPassNumeric: errorPassNumeric,
                errorPassAscDesc: errorPassAscDesc,
                errorPassEquals: errorPassEquals,
                errorPassBirthDay: errorPassValidBirthDay,
                passValid: !hasErrors,
            },
            () => {
                // Auto remove the 'prospects-animation prospects-animation--shake' classes after 1 second or they wont trigger with subsequent errors
                setTimeout(() => {
                    this.setState({ showShakeAnimationOnPasswordError: false });
                }, 1000);
            }
        );
    };

    handlePasswordValidation = value => {
        const {
            userProfile: { birthDate },
        } = this.props;
        const { day: birthDay, month: birthMonth, year: birthYear } = getSeparatedDate(birthDate);
        if (value.length >= 4) {
            const errorPassValidBirthDay =
                birthDayMatchesPassword(value, birthDay, birthMonth) || birthYearMatchesPassword(value, birthYear);
            const errorPassAscDesc = checkAscDescValue(value);
            const errorPassEquals = checkSameDigitsValue(value);
            const errorPassNumeric = checkNumeric(value);
            this.handlePasswordReq(errorPassNumeric, errorPassAscDesc, errorPassEquals, errorPassValidBirthDay);
            return !(errorPassValidBirthDay || errorPassAscDesc || errorPassEquals || errorPassNumeric);
        } else {
            if (document.activeElement.id != 'password') {
                return false;
            }
            this.handlePasswordReq();
            return true;
        }
    };

    handlePasswordRequired = value => {
        if (value && value.length) {
            return true;
        } else {
            this.handleDisplayPasswordReq(false);
            return false;
        }
    };

    handleDisplayPasswordReq = display => this.setState({ displayPassReq: display });

    handleFocus = () => {
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'clave de cliente',
            categoriaEvento: 'interaccion en datos personales',
        });
        this.handleDisplayPasswordReq(true);
    };

    handleChange = event => {
        event.target.value = StringHelper.getDigitsOnly(event.target.value);
    };

    render() {
        const {
            showPassword,
            inputType,
            passwordInputClass,
            iconPasswordClass,
            displayPassReq,
            errorPassAscDesc,
            errorPassEquals,
            errorPassBirthDay,
            showShakeAnimationOnPasswordError,
        } = this.state;
        const iconPasswordClasses = 'icons icons--' + iconPasswordClass;

        return (
            <div className="row md-form-group password-field">
                <div className="col-sm-6">
                    <InputText
                        profileModel="userProfile.password"
                        label={formatText('field-createPassword_ares')}
                        type={inputType}
                        name="password"
                        inputClass={passwordInputClass}
                        maxLength={4}
                        pattern="[0-9]*"
                        id="password"
                        autoCompletePassword="off"
                        isPassword
                        placeholder={formatText('placeholder-password_ares')}
                        messagesError={{ required: formatText('validation-fieldRequired') }}
                        selectTextOnFocus={false}
                        validations={{
                            required: value => this.handlePasswordRequired(value),
                            valid: value => this.handlePasswordValidation(value),
                        }}
                        onFocus={this.handleFocus}
                        onChange={this.handleChange}
                        tooltip={<InfoTooltip text={formatText('tooltip-password_ares')} />}
                        adornment={
                            <i
                                className={iconPasswordClasses + ((showPassword && ' no-valid ') || ' valid ')}
                                onClick={this.handleTogglePassword}
                                onTouchStart={this.handleTogglePassword}
                                onTouchEnd={this.handleTogglePassword}
                            />
                        }
                        {...this.props}
                    />
                </div>
                {displayPassReq && (
                    <div className="col-sm-6">
                        <PasswordRequirement
                            showShakeAnimationOnPasswordError={showShakeAnimationOnPasswordError}
                            errorPassAscDesc={errorPassAscDesc}
                            errorPassEquals={errorPassEquals}
                            errorPassBirthDay={errorPassBirthDay}
                        />
                    </div>
                )}
            </div>
        );
    }
}

Password.propTypes = {
    userProfileForm: PropTypes.object,
    userProfile: PropTypes.object,
    formActions: PropTypes.any,
    enableContinueButton: PropTypes.function,
};

export default Password;
